import { VApp } from 'vuetify/lib/components/VApp';
import { VContent } from 'vuetify/lib/components/VContent';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{attrs:{"id":"app"}},[(_vm.token && _vm.isShowAppBar)?_c('AppBar',{attrs:{"token":_vm.token,"nt_code":_vm.nt_code}}):_vm._e(),_c(VContent,{class:_vm.margin},[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('h3',[_c(VProgressCircular,{staticClass:"mr-1",attrs:{"size":70,"width":7,"indeterminate":"","color":"primary"}}),_vm._v("\n        Loading...\n      ")],1)]):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }